import { postLikeGoods } from './postLikeGoods/postLikeGoods';
import { removeLikeGoods } from './removeLikeGoods';

/**
 * - 최근본 상품의 찜관련 관련 api
 */
export const likeGoodsService = {
  post: postLikeGoods,
  delete: removeLikeGoods,
};
